import { render, staticRenderFns } from "./home-box1.vue?vue&type=template&id=2149b87e&scoped=true&"
import script from "./home-box1.vue?vue&type=script&lang=js&"
export * from "./home-box1.vue?vue&type=script&lang=js&"
import style0 from "./home-box1.vue?vue&type=style&index=0&id=2149b87e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2149b87e",
  null
  
)

export default component.exports